import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ConfigService } from '../app.config'; 


@Injectable()

export class ProductionPlannerService {
    private url="";
    private baseUrl="";
    
  
    constructor(public http: HttpClient,private configService:ConfigService) {
        this.baseUrl = configService.getServiceBaseUrl();      
    }

    getAllProductionPlannerStation() {
        this.url = this.baseUrl + 'api/ProductionPlanner/GetAllProductionPlannerStation';
        return this.http.get(this.url);
    }

    addUpdateProductioPlannerStation(countryInfo){
        this.url = this.baseUrl + 'api/ProductionPlanner/AddUpdateProductioPlannerStation';
        return this.http.post(this.url,countryInfo);
    }

    getAllProductionUserPresence(LoginDate): Observable<any> {
        this.url = this.baseUrl + 'api/ProductionPlanner/GetAllProductionUserPresence?LoginDate=' + LoginDate;
        return this.http.get(this.url);
    }
	
	addUpdateProductioPlannerWorkflow(countryInfo){
        this.url = this.baseUrl + 'api/ProductionPlanner/AddUpdateProductioPlannerWorkflow';
        return this.http.post(this.url,countryInfo);
    }

    getAllProductionPlannerWorkflow() {
        this.url = this.baseUrl + 'api/ProductionPlanner/GetAllProductionPlannerWorkflow';
        return this.http.get(this.url);
    }

    deleteProductionPlannerWorkflow(id: number) {
        this.url = this.baseUrl + 'api/ProductionPlanner/DeleteProductionPlannerWorkflow?id=' + id;
        return this.http.get(this.url);
    }

    usersAttendance(Object){
        this.url = this.baseUrl + 'api/ProductionPlanner/SaveUsersAttendance';
        return this.http.post(this.url,Object);
    }
  
}
